// skills/pilfering/index.js
// Pilfering skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import {
    renderPilferingUI,
    updatePilferingUI,
    initPilferingUI,
    togglePickpocketing,
    upgradeGloves,
    switchTab,
    getCurrentTab,
    activatePilferer,
    deactivatePilferer,
    unlockGuild,
    claimGuildChestItem,
    claimAllGuildChest,
    setGuildChestNotificationThreshold
} from './pilferingUI.js';

/**
 * Pilfering skill configuration
 * Note: Tabs are managed internally (not via router) to preserve state when navigating away
 */
const pilferingConfig = {
    id: 'pilfering',
    name: 'Pilfering',
    icon: '🥷',
    iconImage: 'assets/icons/skill_icons/pilfering.png',
    description: 'Pickpocket NPCs for gold and items',

    // No router-level tabs - pilfering manages tabs internally to preserve state
    // Use getCurrentTab() to access persisted tab state

    render(params = {}) {
        // Use persisted tab state if no tab specified in params
        const effectiveParams = {
            ...params,
            tab: params.tab || getCurrentTab()
        };
        renderPilferingUI(effectiveParams);
    },

    update() {
        updatePilferingUI();
    },

    init() {
        initPilferingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('pilfering', pilferingConfig);

if (typeof window !== 'undefined') {
    window.pilferingUI = {
        togglePickpocketing,
        upgradeGloves,
        switchTab,
        activatePilferer,
        deactivatePilferer,
        unlockGuild,
        claimGuildChestItem,
        claimAllGuildChest,
        setGuildChestNotificationThreshold
    };
}

export default pilferingConfig;
